/**
 * Acqs composer Templates picker — apply a `composerFill` HX-Trigger (acqs/views/responses.py
 * `response_fill`) to the email or SMS composer it names: { form, subject, body }.
 *
 * `subject` null leaves the subject alone (a reply, or SMS); the body fills
 * `textarea[name=body]` (email) or `textarea[name=message]` (SMS) and fires `input` so
 * data-autoresize re-fits it.  Nothing here sends.  Suggest reply and Improve answer the AI
 * Suggestion card instead (static/js/src/email-ai.js).
 *
 * The SMS composer's `[data-char-count]` shows the message length against `data-char-limit`,
 * red when over.  It follows every `input` (typing, a fill, Accept) and a form reset (a send).  On a lead's
 * SMS sheet and the lead page's SMS panel (`data-char-count-typed`, inside the input) it shows once there is text,
 * and stays hidden in instruction mode.
 *
 * The seller bot's mode picker (acqs/_bot_mode_picker.html, a hidden `send_as` a send's form reset leaves
 * alone, and a refresh passes back while it is instruction): a pick sets it; instruction mode disables the tools
 * (`data-bot-tools`) in place, follows the trigger's label and the placeholder, and shows the `data-bot-mode` line for the mode.
 * `window.acqsBotComposerSync(form)` re-applies this after acqs-ws.js swaps the picker.
 *
 * On the SMS composer (SeeMe file-attach, `fileattach:change`) the message is optional while an image is attached.
 */

(function () {
    if (window.__acqsComposerFillBound) return;
    window.__acqsComposerFillBound = true;

    // The same pairs as acqs/_bot_mode_picker.html and acqs/_lead_sms_composer.html.
    var MODE_LABEL = { instruction: 'Bot', message: 'Text' };
    var PLACEHOLDER = { instruction: 'Tell the bot…', message: 'Text the seller…' };

    function updateCharCount(form) {
        var counter = form && form.querySelector('[data-char-count]');
        var message = counter && form.querySelector('textarea[name="message"]');
        if (!message) return;
        var limit = parseInt(counter.dataset.charLimit, 10);
        var length = Array.from(message.value).length;  // code points, as the card counts
        counter.textContent = length + ' / ' + limit;
        counter.classList.toggle('text-error', length > limit);
        counter.classList.toggle('text-muted', length <= limit);
        if (counter.hasAttribute('data-char-count-typed')) {
            counter.hidden = botMode(form) === 'instruction' || length === 0;
        }
    }

    function botMode(form) {
        var sendAs = form.querySelector('input[name="send_as"]');
        return sendAs ? sendAs.value : 'message';
    }

    function syncBotMode(form) {
        var mode = botMode(form);
        form.querySelectorAll('[data-bot-mode]').forEach(function (el) {
            el.classList.toggle('d-none', el.dataset.botMode !== mode);
        });
        var picker = form.querySelector('[data-bot-mode-picker]');
        if (!picker) return;
        form.querySelectorAll('[data-bot-tools] button').forEach(function (button) {
            button.disabled = mode === 'instruction';
        });
        var label = picker.querySelector('[data-bot-mode-label]');
        if (label) label.textContent = MODE_LABEL[mode];
        var message = form.querySelector('textarea[name="message"]');
        if (message) message.placeholder = PLACEHOLDER[mode];
        var menu = window._cc && window._cc.findIn ? window._cc.findIn(picker, '.dropdown-menu') : picker.querySelector('.dropdown-menu');
        if (menu) {
            menu.querySelectorAll('[data-bot-mode-choice]').forEach(function (item) {
                item.classList.toggle('active', item.dataset.botModeChoice === mode);
            });
        }
        updateCharCount(form);
    }

    window.acqsBotComposerSync = syncBotMode;

    // A delegated click, on the document: the menu may be portaled out of the form.
    document.addEventListener('click', function (e) {
        var item = e.target.closest && e.target.closest('[data-bot-mode-choice]');
        if (!item) return;
        var form = window._cc.ownerOf(item, 'form');
        if (!form) return;
        form.querySelector('input[name="send_as"]').value = item.dataset.botModeChoice;
        syncBotMode(form);
        var message = form.querySelector('textarea[name="message"]');
        if (message) message.focus();
    });

    document.body.addEventListener('input', function (e) {
        if (e.target.name === 'message') updateCharCount(e.target.form);
    });

    // `reset` fires before the fields clear, so count after it.
    document.body.addEventListener('reset', function (e) {
        var form = e.target;
        setTimeout(function () { updateCharCount(form); });
    });

    // An SMS may be image-only: the message is optional while the file-attach list holds an image.
    document.body.addEventListener('fileattach:change', function (e) {
        var message = e.target.querySelector('textarea[name="message"]');
        if (message) message.required = e.detail.files.length === 0;
    });

    document.body.addEventListener('composerFill', function (e) {
        var detail = e.detail || {};
        var form = detail.form && document.getElementById(detail.form);
        if (!form) return;
        if (detail.subject !== null && detail.subject !== undefined) {
            var subject = form.querySelector('input[name="subject"]');
            if (subject) subject.value = detail.subject;
        }
        var body = form.querySelector('textarea[name="body"], textarea[name="message"]');
        if (body) {
            body.value = detail.body || '';
            body.dispatchEvent(new Event('input', { bubbles: true }));
            body.focus();
        }
    });
})();
